import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	errorFlagTitle: {
		id: 'editor-presets.conflict-resolution-plugin.copy-page.error-flag.title.non-final',
		defaultMessage: 'We failed to create a copy',
		description: 'Title for the error flag if copying conflicted page fails',
	},
	errorFlagDescription: {
		id: 'editor-presets.conflict-resolution-plugin.copy-page.error-flag.description.non-final',
		defaultMessage: 'Check your network connection or try again.',
		description: 'Description for the error flag if copying conflicted page fails',
	},
	copyCreatedFlagTitle: {
		id: 'editor-presets.conflict-resolution-plugin.copy-page.copy-created-flag.title.non-final',
		defaultMessage: 'Copy created',
		description: 'Title for the flag if copying conflicted page is successful',
	},
	copyCreatedFlagDescription: {
		id: 'editor-presets.conflict-resolution-plugin.copy-page.copy-created-flag.description.non-final',
		defaultMessage: 'We copied your offline edits into a new page. Your changes were saved.',
		description: 'Description for the flag if copying conflicted page is successful',
	},
	copyCreatedFlagViewPage: {
		id: 'editor-presets.conflict-resolution-plugin.copy-page.copy-created-flag.view-page-link.non-final',
		defaultMessage: 'View page',
		description: 'Description for the flag if copying conflicted page is successful',
	},
	createCopyFlagTitle: {
		id: 'editor-presets.conflict-resolution-plugin.copy-page.create-copy-flag.title.non-final',
		defaultMessage: 'Copy offline edits as a new page',
		description:
			'Title for the flag to warn and allow copy if a conflicted page is detected on reconnection',
	},
	createCopyFlagDescription: {
		id: 'editor-presets.conflict-resolution-plugin.copy-page.create-copy-flag.description.non-final',
		defaultMessage: 'You can copy your offline edits in case they conflict with online changes.',
		description:
			'Description for the flag to warn and allow copy if a conflicted page is detected on reconnection',
	},
	createCopyFlagCreateAction: {
		id: 'editor-presets.conflict-resolution-plugin.copy-page.create-copy-flag.create-action.non-final',
		defaultMessage: 'Create copy',
		description:
			'Action in a flag to create a copy of the page if a conflicted page is detected on reconnection',
	},
	createCopyFlagNoAction: {
		id: 'editor-presets.conflict-resolution-plugin.copy-page.create-copy-flag.no-action.non-final',
		defaultMessage: 'No thanks',
		description:
			'Action in a flag to dismiss the flag to create a copy if a conflicted page is detected on reconnection',
	},
});
